<template>
  <div
    style="
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    "
  >
    <div
      class="d-flex selector-container section-container"
      :class="{ dark: skinType }"
    >

      <!-- <div class="section-header">
        <div class="lan"></div>
        <div class="tip4text">视频监控</div>
      </div> -->
      <SectionTitle title="视频监控"></SectionTitle>

      <project-level-selector
        @selectItem="selectItemListener"
        levelType="pds"
      ></project-level-selector>
    </div>

    <div
      class="videocontent section-container"
      :class="{ dark: skinType }"
      v-if="videoList"
    >
      <div
        v-for="(item, i) in videoList"
        :key="i"
        class="d-flex"
        :style="{ height: height1, width: width1 }"
        @click="showDia(item)"
      >
        <single-video
          :videoId="i"
          :token="videoToken"
          :videoUrl="item"
          @showVideo="showDia"
        ></single-video>
      </div>
    </div>
    <no-data-temporarily v-else class="videocontent"></no-data-temporarily>
    <el-dialog
      v-if="selectMonitor"
      :title="`${selectMonitor.NickName}#监控`"
      :visible.sync="centerDialogVisible"
      style="margin-top: -10vh"
      width="80%"
      center
      :class="{ dark: skinType }"
    >
      <div class="Popcont">
        <single-video
          :videoId="`channel+${selectMonitor.ChannelNo}`"
          :token="videoToken"
          :videoType="1"
          :videoUrl="selectMonitor"
        >
        </single-video>
        <control
          class="left-xia"
          :deviceSerial="selectMonitor.DeviceSerial"
          :channelNo="parseInt(selectMonitor.ChannelNo, 10)"
        ></control>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import control from '@/components/realtime-monitoring/video-monitor/utils/control.vue';
import { videoMonitor, getToken } from '@/api/video-monitor/video-monitor';
import SingleVideo from '@/components/realtime-monitoring/video-monitor/utils/single-video.vue';
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  data() {
    return {
      selectMonitor: null,
      centerDialogVisible: false,
      selectRoom: null,
      videoList: [],
      videoToken: '',
    };
  },
  created() {
    this.requestToken();
  },
  components: {
    ProjectLevelSelector,
    SingleVideo,
    control,
    NoDataTemporarily,
    SectionTitle,
  },
  watch: {
    selectRoom() {
      this.requestVideoList();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    height1() {
      if (this.videoList === null) {
        return 0;
      }
      let h = 0;
      h = '33.3%';
      switch (this.videoList.length) {
        case 1:
          h = '99%';
          break;
        case 2:
          h = '70%';
          break;
        default:
          h = '50%';
          break;
      }
      return h;
    },
    width1() {
      let w = 0;
      w = '33.3%';
      switch (this.videoList.length) {
        case 1:
          w = '99%';
          break;
        case 2:
        case 4:
          w = '49%';
          break;
        case 3:
        case 5:
        case 6:
          w = '33.3%';
          break;
        default:
          w = '33.3%';
          break;
      }
      return w;
    },
  },
  methods: {
    selectItemListener(selectItem) {
      if (selectItem.oType === 'pds') {
        this.selectRoom = selectItem;
      }
    },
    // 请求视频列表接口
    requestVideoList() {
      if (!this.selectRoom) {
        this.videoList = null;
        return;
      }
      videoMonitor({
        StationIDstr: this.selectRoom.IdStr,
      })
        .then((res) => {
          console.log(res);
          this.videoList = res;
        })
        .catch(() => {
          this.videoList = null;
        });
    },
    // 获取token
    requestToken() {
      getToken().then((res) => {
        console.log(res);
        this.videoToken = res;
      });
    },
    // 展示diaolog
    showDia(item) {
      this.selectMonitor = item;
      this.centerDialogVisible = true;
    },
    // 接受选择配电室的值
    queryRoom(room) {
      this.selectRoom = room;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  height: 80%;
}
/deep/.el-dialog__body {
  height: 80%;
}
.peidianroom {
  width: 100%;
  height: 6%;
  display: flex;
  align-items: center;
  background: white;
  position: relative;
  border-bottom: 0.1rem solid #dddcdc;
}
.section-header {
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  padding: 0 1rem 0 0.5rem;
}
.lan {
  width: 0.28rem;
  height: 1.5rem;
  background: #2e9bf3;
}
.tip4text {
  font-size: 1.2rem;
  margin: 0 0.6rem;
}
.videocontent {
  width: 100%;
  height: 94%;
  display: flex;
  border-radius: 0.2rem;
  flex-wrap: wrap;
  align-items: center;
  overflow: auto;
}
.query-room {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-color {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.videosp {
  width: 99%;
  height: 92%;
  background: cornsilk;
}
.monitor {
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
}
.Popcont {
  width: 100%;
  height: 100%;
  position: relative;
  border: solid 1px #000;
}
</style>
